import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  GoalFilterDocument,
} from 'shared/types/filter-document';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import {
  GoalSortingMode,
  GroupByMode,
  SortingMode,
} from 'shared/types/sorting-mode';

export const defaultFilter = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): FilterDocument => ({
  sortingMode: SortingMode.Custom,
  groupByMode: GroupByMode.Section,
  filters: {
    [FilterOptionKeys.Goal]: {
      include: [goal?.id ?? '', ...subGoalIds],
    },
  },
});

export const getFilterDocument = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): FilterDocument => {
  const base = defaultFilter(goal, subGoalIds);

  return {
    ...base,
    ...(goal?.filterDocument ?? {}),
    showCompleted: !(goal?.hideCompletedTasks ?? true),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(goal?.filterDocument?.filters ?? {}),
    },
  };
};

export const getGoalFilterDocument = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): GoalFilterDocument => {
  const base = goal?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]:
      base.groupByMode ?? GroupByMode.None,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ?? goal?.goalSortingMode ?? GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.Goal]: {
        include: [...subGoalIds],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base[DocumentOrganizationKeys.CollapsedSections] ??
      goal?.collapsedSubGoals ??
      subGoalIds,
  };
};
